//Content type tags
export const TITLE = "title";
export const SUB_TITLE = "sub title";
export const DESCRIPTION = "description";
export const FEATURED_ITEMS = "featured items";
export const IMAGE = "image";
export const LOCATIONS = "locations";
export const EMAIL = "email";
export const GALLERY = "gallery";
export const PUBLISHING_DETAIL = "publishing details";
export const PUBLISHING_YEAR = "publishing year";
export const NAME = "name";
export const DESIGNATION = "designation";
export const CONTENT = "content";
export const DATE = "date";
export const SOCIAL = "socials";
export const BOOK = "book";
export const BUY_BUTTON = "buy button";
export const USER = "user";
export const VOLUNTEER = "volunteer";
export const RESPONSE_TAG = "response";
export const REGISTER = "register";
export const REGISTER_TOAST = "register toast";
export const HOME_SLIDER_SECTION = "home slider section";
export const HOME_EPIC_SECTION = "home epic section";
export const HOME_CREATOR_SECTION = 'home creator section';
export const CREATOR_SECTION = 'creator section';
export const CONTACT_INFORMATION_SECTION = 'contact information section';
export const SUBSCRIBE_FORM_SECTION = "subscribe form section";
export const SUBSCRIPTION_EMAIL_TAG = "subscribe email tag";
export const EPIC_SCENICQUPTE_SECTION = "epics scenicquote section";
export const FOOTER_SECTION = "footer section";
